import { z } from "zod";

import { MetadataSchema } from "api/schemas/common";

// Active patients
const ClinicPartnerActivePatientsArgsSchema = z.object({
  params: z.object({
    start_time: z.string(),
  }),
});
export type GetClinicPartnerActivePatientsArgs = z.infer<typeof ClinicPartnerActivePatientsArgsSchema>;

const ClinicPartnerActivePatientsItemSchema = z.object({
  month: z.string(),
  total: z.number(),
});
export type ClinicPartnerActivePatientsItem = z.infer<typeof ClinicPartnerActivePatientsItemSchema>;

export const GetClinicPartnerActivePatientsResponseSchema = z.object({
  items: z.array(ClinicPartnerActivePatientsItemSchema),
});
export type GetClinicPartnerActivePatientsResponse = z.infer<typeof GetClinicPartnerActivePatientsResponseSchema>;

// Enrolled patients
const ClinicPartnerEnrolledPatientsArgsSchema = z.object({
  params: z.object({
    start_time: z.string(),
  }),
});
export type GetClinicPartnerEnrolledPatientsArgs = z.infer<typeof ClinicPartnerEnrolledPatientsArgsSchema>;

const ClinicPartnerEnrolledPatientsItemSchema = z.object({
  month: z.string(),
  total: z.number(),
});
export type ClinicPartnerEnrolledPatientsItem = z.infer<typeof ClinicPartnerEnrolledPatientsItemSchema>;

export const GetClinicPartnerEnrolledPatientsResponseSchema = z.object({
  items: z.array(ClinicPartnerEnrolledPatientsItemSchema),
});
export type GetClinicPartnerEnrolledPatientsResponse = z.infer<typeof GetClinicPartnerEnrolledPatientsResponseSchema>;

// Avg functionality
const ClinicPartnerAvgFunctionalityItemSchema = z.object({
  avg_functionality: z.number(),
  week_number: z.number(),
});
export type ClinicPartnerAvgFunctionalityItem = z.infer<typeof ClinicPartnerAvgFunctionalityItemSchema>;

export const GetClinicPartnerAvgFunctionalityResponseSchema = z.object({
  items: z.array(ClinicPartnerAvgFunctionalityItemSchema),
});
export type GetClinicPartnerAvgFunctionalityResponse = z.infer<typeof GetClinicPartnerAvgFunctionalityResponseSchema>;

// Avg pain
const ClinicPartnerAvgPainItemSchema = z.object({
  avg_pain: z.number(),
  week_number: z.number(),
});
export type ClinicPartnerAvgPainItem = z.infer<typeof ClinicPartnerAvgPainItemSchema>;

export const GetClinicPartnerAvgPainResponseSchema = z.object({
  items: z.array(ClinicPartnerAvgPainItemSchema),
});
export type GetClinicPartnerAvgPainResponse = z.infer<typeof GetClinicPartnerAvgPainResponseSchema>;

// Avg NPS
export const GetClinicPartnerAvgNpsResponseSchema = z.object({
  avg_nps: z.number(),
});
export type GetClinicPartnerAvgNpsResponse = z.infer<typeof GetClinicPartnerAvgNpsResponseSchema>;

const GetClinicPartnerPatientsArgsSchema = z.object({
  params: z.object({
    clinic_partner_ids: z.array(z.number()).optional(),
    limit: z.number(),
    page: z.number(),
    q: z.string().optional(),
  }),
});
export type GetClinicPartnerPatientsArgs = z.infer<typeof GetClinicPartnerPatientsArgsSchema>;

const ClinicPartnerPatientSchema = z.object({
  adherence: z.number(),
  created_at: z.string(),
  deleted_at: z.string().nullable(),
  external_id: z.string().nullable(),
  icd_codes: z.array(z.string()).nullable(),
  id: z.number(),
  invited_by: z.string().nullable(),
  kickoff_appointment_at: z.string().nullable(),
  latest_note_at: z.string().nullable(),
  name: z.string(),
  sources: z.array(z.string()).nullable(),
});
export type ClinicPartnerPatient = z.infer<typeof ClinicPartnerPatientSchema>;

export const GetClinicPartnerPatientsResponseSchema = z.object({
  items: z.array(ClinicPartnerPatientSchema),
  metadata: MetadataSchema,
});
